/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetTabsSummary200Response
 */
export interface GetTabsSummary200Response {
    /**
     * 
     * @type {number}
     * @memberof GetTabsSummary200Response
     */
    tabs: number;
    /**
     * 
     * @type {number}
     * @memberof GetTabsSummary200Response
     */
    discounts: number;
    /**
     * 
     * @type {number}
     * @memberof GetTabsSummary200Response
     */
    billsRemoved: number;
    /**
     * 
     * @type {number}
     * @memberof GetTabsSummary200Response
     */
    productsRemovedAfterBilling: number;
    /**
     * 
     * @type {number}
     * @memberof GetTabsSummary200Response
     */
    productsRemovedBeforeBilling: number;
}

/**
 * Check if a given object implements the GetTabsSummary200Response interface.
 */
export function instanceOfGetTabsSummary200Response(value: object): value is GetTabsSummary200Response {
    if (!('tabs' in value) || value['tabs'] === undefined) return false;
    if (!('discounts' in value) || value['discounts'] === undefined) return false;
    if (!('billsRemoved' in value) || value['billsRemoved'] === undefined) return false;
    if (!('productsRemovedAfterBilling' in value) || value['productsRemovedAfterBilling'] === undefined) return false;
    if (!('productsRemovedBeforeBilling' in value) || value['productsRemovedBeforeBilling'] === undefined) return false;
    return true;
}

export function GetTabsSummary200ResponseFromJSON(json: any): GetTabsSummary200Response {
    return GetTabsSummary200ResponseFromJSONTyped(json, false);
}

export function GetTabsSummary200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTabsSummary200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'tabs': json['tabs'],
        'discounts': json['discounts'],
        'billsRemoved': json['billsRemoved'],
        'productsRemovedAfterBilling': json['productsRemovedAfterBilling'],
        'productsRemovedBeforeBilling': json['productsRemovedBeforeBilling'],
    };
}

export function GetTabsSummary200ResponseToJSON(json: any): GetTabsSummary200Response {
    return GetTabsSummary200ResponseToJSONTyped(json, false);
}

export function GetTabsSummary200ResponseToJSONTyped(value?: GetTabsSummary200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tabs': value['tabs'],
        'discounts': value['discounts'],
        'billsRemoved': value['billsRemoved'],
        'productsRemovedAfterBilling': value['productsRemovedAfterBilling'],
        'productsRemovedBeforeBilling': value['productsRemovedBeforeBilling'],
    };
}

